import React from 'react';
import { connect } from 'react-redux';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';

import Frame from '../../Wrappers/Frame';
import { testWindow } from '../../Wrappers/MainWindow';
import ApplyMenu from './ApplyMenu';
import * as applyOffersActions from '../../../redux/applyOffers';
import { instagramRound } from '../../../helpers';
import InstagramFeed from './InstagramFeed';
import ModelStats from './ModelStats';
import dismissedIcon from '../../../svg/dismissed.svg';
import likedIcon from '../../../svg/liked.svg';
import selectedIcon from '../../../svg/selected.svg';
import unreviewedIcon from '../../../svg/unreviewed.svg';
import instagramIcon from '../../../svg/instagram-icon.svg';
import leftArrow from '../../../svg/gray-arrow-left.svg';
import rightArrow from '../../../svg/gray-arrow-right.svg';
import lockIcon from '../../../svg/lock.svg';
import './apply-offer-applicant.scss';
import Modal from '../Partials/Modal';

interface Props {
  location: any;
  match: any;
  applyOffers: any;
  fetchAndSetCurrentApplicant: Function;
  goToOverview: Function;
  setApplicantStatus: Function;
  goToNewApplicant: Function;
}

interface State {
  modalSelectedFull: Boolean;
  modalApplicantFinalized: Boolean;
}
class ApplyOffer extends React.Component<Props, State> {
  state: State = { modalSelectedFull: false, modalApplicantFinalized: false };

  componentDidMount() {
    if (!this.props.applyOffers.currentApplicant) {
      this.props.fetchAndSetCurrentApplicant(
        this.props.match.params.offerId,
        this.props.match.params.applicantId
      );
    }
  }

  componentDidUpdate() {
    // If the applicants array is empty, that means we've taken an action on the
    // last attendee and moved them to another category. When this happens, we
    // move the user back to the overview page.
    if (this.props.applyOffers.applicants.length === 0) {
      this.goToOverview(this.props.applyOffers.selectedFilter);
    }
  }

  goToOverview(filter: ApplyOfferApplicantStatus) {
    this.props.goToOverview(`/offer/apply/${this.props.match.params.offerId}`, filter);
  }

  updateApplicantStatus(status: ApplyOfferApplicantStatus) {
    this.props.setApplicantStatus(
      this.props.applyOffers.offer.id,
      this.props.applyOffers.currentApplicant,
      status
    );
  }

  buildNextAndPreviousButtons() {

    let   index  = 0;
    const length = this.props.applyOffers.applicants.length;

    if (this.props.applyOffers.currentApplicant) {
      index = this.props.applyOffers.applicants.map((a) => a.id).indexOf(this.props.applyOffers.currentApplicant.id);
    }

    const hasPreviousModel = index - 1 >= 0;
    const hasNextModel = index + 1 < length;

    return (
      <div className="prev-next-buttons">
        <button style={{visibility: hasPreviousModel ? 'visible' : 'hidden'}} onClick={() => this.props.goToNewApplicant(false)}>
          &lt; <span>previous model</span>
        </button>

        <button style={{visibility: hasNextModel ? 'visible' : 'hidden'}} onClick={() => this.props.goToNewApplicant(true)}>
          <span>next model</span> &gt;
        </button>
      </div>
    );
  }

  // Builds the actions buttons to promote or denote an applicant. The actions and texts will
  // be different depending on the selected filter.
  buildActionButtons() {
    let denote;
    let denoteText;
    let denoteIcon;
    let promote;
    let promoteText;
    let promoteIcon;

    switch (this.props.applyOffers.selectedFilter) {
      case 'dismissed':
        denote = 'unreviewed';
        denoteText = 'Unreview';
        denoteIcon = unreviewedIcon;
        promote = 'liked';
        promoteText = 'Like';
        promoteIcon = likedIcon;
        break;
      case 'unreviewed':
        denote = 'dismissed';
        denoteText = 'Dismiss';
        denoteIcon = dismissedIcon;
        promote = 'liked';
        promoteText = 'Like';
        promoteIcon = likedIcon;
        break;
      case 'liked':
        denote = 'dismissed';
        denoteText = 'Dismiss';
        denoteIcon = dismissedIcon;
        promote = 'selected';
        promoteText = 'Select';
        promoteIcon = selectedIcon;
        break;
      case 'selected':
        denote = 'dismissed';
        denoteText = 'Dismiss';
        denoteIcon = dismissedIcon;
        promote = 'liked';
        promoteText = 'Unselect';
        promoteIcon = selectedIcon;
        break;
      default:
        break;
    }

    let promoteDisabled = false;
    let disabledButtonCallback;
    let denoteDisabled = false;
    // If the model we are viewing is "liked" and the "selected" bucket is
    // already full, we disable the "select" button.
    const selectedBucket = this.props.applyOffers.buckets.find(
      (bucket) => bucket.name === 'selected'
    );
    if (
      this.props.applyOffers.selectedFilter === 'liked' &&
      selectedBucket.count_of_models === this.props.applyOffers.offer.available_spots
    ) {
      promoteDisabled = true;
      disabledButtonCallback = () => this.setState({ modalSelectedFull: true });
    }

    // If an offer has been reopened, disable both the promote and denote for
    // any model that has already been finalized.
    if (
      this.props.applyOffers.selectedFilter === 'selected' &&
      this.props.applyOffers.currentApplicant.is_locked
    ) {
      promoteDisabled = true;
      denoteDisabled = true;
      disabledButtonCallback = () => this.setState({ modalApplicantFinalized: true });
    }

    const denoteButton = (
      <button
        className={denoteDisabled ? `${denote} disabled` : denote}
        onClick={denoteDisabled ? disabledButtonCallback : () => this.updateApplicantStatus(denote)}
      >
        <div className={denote === 'unreviewed' ? 'left denote smaller' : 'left denote'}>
          <img alt="" src={denoteIcon}></img>
        </div>
        <div className="denote right">
          <p className="text">{denoteText}</p>
        </div>
      </button>
    );

    const promoteButton = (
      <button
        className={promoteDisabled ? `${promote} disabled` : promote}
        onClick={
          promoteDisabled ? disabledButtonCallback : () => this.updateApplicantStatus(promote)
        }
      >
        <div className="left promote">
          <img alt="" src={promoteIcon}></img>
        </div>
        <div className="promote right">
          <p>{promoteText}</p>
        </div>
      </button>
    );

    return (
      <div className="denote-promote">
        {denoteButton}
        {promoteButton}
      </div>
    );
  }

  buildModelSlideshow() {
    const splideImages: JSX.Element[] = [];
    this.props.applyOffers.currentApplicant.model.media.forEach((element) => {
      splideImages.push(
        <div className="each-slide" key={element.path}>
          <img alt="" src={element.path} />
        </div>
      );
    });

    return (
      <Slide
        {...{
          transitionDuration: 200,
          autoplay: false,
          indicators: true,
          prevArrow: (
            <div className="prev">
              <img src={leftArrow} />
            </div>
          ),
          nextArrow: (
            <div className="next">
              <img src={rightArrow} />
            </div>
          ),
        }}
      >
        {splideImages}
      </Slide>
    );
  }

  render() {
    const currentApplicant = this.props.applyOffers.currentApplicant;
    if (!currentApplicant) return 'Loading...';

    return (
      <Frame
        classes="apply-offer-applicant"
        title={`${this.props.applyOffers.offer.subtitle} > ${currentApplicant.status.capitalize()} > ${currentApplicant.model.name}`}
        fullHeight={true}
      >
        <>
          <ApplyMenu allowDownload={false} buttonAction={this.goToOverview.bind(this)} />
          <h1>{currentApplicant.model.name}</h1>
          {this.props.applyOffers.offer.is_stats_required ? (
            <ModelStats applicant={currentApplicant} />
          ) : null}
          <section className="content-wrapper">
            {this.state.modalSelectedFull ? (
              <Modal
                title="Selections are full"
                id="selected-full"
                close={() => this.setState({ modalSelectedFull: false })}
              >
                You have already selected the maximum number of applicants for this offer. To select{' '}
                {currentApplicant.model.name} please first unselect another applicant.
              </Modal>
            ) : null}
            {this.state.modalApplicantFinalized ? (
              <Modal
                title="Applicant already finalized"
                id="already-finalized"
                close={() => this.setState({ modalApplicantFinalized: false })}
              >
                You can not change the status of {currentApplicant.model.name} since they have
                already been finalized for this offer.
              </Modal>
            ) : null}
            <div className="left">
              <div className="image-wrapper">
                {currentApplicant.status === 'selected' ? (
                  currentApplicant.is_locked ? (
                    <div className="banner finalized">
                      <img className="lock" src={lockIcon}></img>finalized
                    </div>
                  ) : (
                    <div className="banner selected">selected</div>
                  )
                ) : null}
                {this.buildModelSlideshow()}
              </div>
              {this.buildActionButtons()}
            </div>
            <div className="right">
              {currentApplicant.model.instagram ? (
                <>
                  <div className="instagram-info">
                    <img className="icon" src={instagramIcon}></img>
                    <span className="text">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={currentApplicant.model.instagram.profile_url}
                        className="handle"
                      >
                        @{currentApplicant.model.instagram.handle}
                      </a>{' '}
                      | {instagramRound(currentApplicant.model.instagram.number_of_followers)}{' '}
                      Followers
                    </span>
                  </div>
                  <InstagramFeed applicant={currentApplicant} />
                </>
              ) : (
                'No instagram'
              )}
            </div>
          </section>
          {this.buildNextAndPreviousButtons()}
        </>
      </Frame>
    );
  }
}

const mapStateToProps = ({ applyOffers }) => ({ applyOffers });

export default connect(mapStateToProps, applyOffersActions)(testWindow(ApplyOffer, 'offers'));
